export * from './ReadonlyLabelWithIcon.ctrl';
export type { ReadonlyLabelWithIconData, ReadonlyLabelWithIconMetadata } from './readonlyLabelWithIcon.model';
